import { PAYMENTS, paymentSessionPath } from "../configs/routes.js";
import api from "./api.js";

export const createPayment = (body) =>
    new Promise((resolve, reject) => {
        api
            .post(PAYMENTS, body, { timeout: 60000 })
            .then((response) => resolve(response.data ?? null))
            .catch((err) => reject(err));
    });

export const getPayments = (params = {}) =>
    new Promise((resolve, reject) => {
        api
            .get(PAYMENTS, { params, timeout: 60000 })
            .then((response) => resolve(response.data ?? null))
            .catch((err) => reject(err));
    });

export const finalizeSessionPayment = (sessionId) =>
    new Promise((resolve, reject) => {
        api
            .post(paymentSessionPath(sessionId), null, { timeout: 60000 })
            .then((response) => resolve(response.data ?? null))
            .catch((err) => reject(err));
    });
